import React from 'react'
import { Col, Row } from 'reactstrap'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import { yesno } from 'src/helpers/displayhelpers'
import { StaffingAgencyDetailsById } from 'src/queries'

interface ListProps {
  agency: StaffingAgencyDetailsById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { agency } = props
  const section1: Array<Omit<ItemProps, 'id'>> = [
    { title: 'Name', value: agency?.name },
    { title: 'SDVOSB', value: yesno(agency?.staffingAgency?.sdvosb) },
    { title: 'Cleared Facility', value: agency?.staffingAgency?._clearedFacility?.name }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: agency === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <Row>
      <Col>
        <DescriptionList {...dlProps}>
          {section1.map(item => {
            const key = item.title.toLowerCase().replace(' ', '-')
            return <Item {...item} key={key} id={key} />
          })}
        </DescriptionList>
      </Col>
    </Row>
  )
}

export default List
